import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'app-logo-small',
	templateUrl: './logo-small.component.html',
	styleUrls: ['./logo-small.component.scss']
})
export class LogoSmallComponent implements OnInit {

	@Input() size = 'small'; // small x-small
	@Input() title = 'Home';

	ngOnInit() {
	}
}
